import React from 'react';
import { Route, Switch } from 'react-router-dom';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import '../css/Warehouse.css';
import FormAddPromotion from './FormAddPromotion';
import ListPromotion from './ListPromotion';
import MyUtil from '../../functions/MyUtil';
import TableViewPromo from '../listPromotion/TableViewPromo';

const Promotion = (props) => {
  const { match } = props;
  return (
    <div>
      <Switch>
        {MyUtil.hasPermission(match.url, 'view') && (
          <Route
            exact
            path={`${match.url}`}
            component={() => <ListPromotion match_parent={match} />}
          />
        )}
        {MyUtil.hasPermission(match.url, 'add') && (
          <Route
            path={`${match.url}/add-promotion`}
            component={FormAddPromotion}
          />
        )}
        {MyUtil.hasPermission(match.url, 'update') && (
          <Route
            path={`${match.url}/edit-promotion/:promo_id`}
            component={FormAddPromotion}
          />
        )}

        <Route
          path={`${match.url}/view-promotion/:promo_code`}
          component={TableViewPromo}
        />
      </Switch>
    </div>
  );
};

export default Promotion;
